export const isDevelopment = () => process.env.NODE_ENV === "development";
export const isRelease = () => process.env.NODE_ENV === "production";
export const isTest = () => process.env.NODE_ENV === "test";
export const isCI = () => process.env.CI === "true";

export const isNotRelease = () => !isRelease();
